/**
 * 性能指标上报。回调触发发送，页面隐藏时补发；同一指标使用递增序号。
 * 每条带:构建版本、路由(商品页不带具体 slug,好按页面聚合)、网络类型。
 */
import { onLCP, onINP, onCLS, onTTFB, type Metric } from "web-vitals";
import { metricRecord, type MetricRecord } from "./metric-record";

const VERSION = import.meta.env.VITE_VERSION as string;
const entryURL = performance.getEntriesByType("navigation")[0]?.name || location.href;
const queue = new Map<string, MetricRecord>();
const sequences = new Map<string, number>();
const connection = () => (navigator as Navigator & { connection?: { effectiveType?: string } }).connection?.effectiveType ?? "";

function push(m: Metric) {
  const sequence = (sequences.get(m.id) ?? 0) + 1;
  sequences.set(m.id, sequence);
  queue.set(m.id, metricRecord(m, sequence, { entryURL, version: VERSION, connection: connection() }));
  // 库的隐藏事件回调可能晚于我们的监听器。回调本身也安排发送，避免最后一批留在队列里。
  queueMicrotask(flush);
}
onLCP(push); onINP(push); onCLS(push); onTTFB(push);

let retries = 0;
let retryTimer: ReturnType<typeof setTimeout> | undefined;
function flush() {
  if (queue.size === 0) return;
  const batch = [...queue.values()];
  queue.clear();
  fetch("/api/vitals", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(batch), keepalive: true })
    .then((res) => {
      if (!res.ok && !(res.status >= 400 && res.status < 500 && res.status !== 429)) throw new Error("vitals report failed");
      // 永久性 4xx 丢弃这一批，不反复重试。
      retries = 0;
    })
    .catch(() => {
      for (const row of batch) {
        if ((queue.get(row.metricId)?.sequence ?? 0) < row.sequence) queue.set(row.metricId, row);
      }
      if (retries < 3 && !retryTimer) {
        const wait = 1000 * 2 ** retries++;
        retryTimer = setTimeout(() => { retryTimer = undefined; flush(); }, wait);
      }
    });
}
addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") flush(); });
addEventListener("pagehide", flush);

addEventListener("online", () => { retries = 0; flush(); });
addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") { retries = 0; flush(); } });
